import { defineStore } from 'pinia';
import {Mode} from "@/constants/constants";

export const useAppStore = defineStore('app', {
  state: () => ({
    mode: null,
    workflow: null,
    redirectRouteName: null, // Store route name instead of path
    redirectRouteParams: null, // Store route params if needed
    redirectRouteQuery: null, // Store route query if needed
    currentOrderId: null,
    currentOrderGuid: null,
    currentMealPlanOrderId: null,
    currentOrderMenuOrderType: null,
    selectedMealPlanDate: null,
    externalBackGuardArmed: false,
    externalEntryRootRouteName: null,
    orderEntryRouteName: null,
    tableOrderEntryRouteName: null,
    flashToast: null,
    allowTableModeOrderParametersNavigation: false,
  }),
  getters: {
    hasWorkflow: (state) => !!state.workflow,
    uppercaseMode: (state) => state.mode ? state.mode.toUpperCase() : null,
    getSelectedMealPlanDate: (state) => state.selectedMealPlanDate,
  },
  actions: {
    setMode(mode) {
      this.mode = mode;
      if (mode !== Mode.TABLE && mode !== Mode.TAKEAWAY) {
        this.orderEntryRouteName = null;
        this.tableOrderEntryRouteName = null;
      }
    },
    isMode(mode) {
      return this.mode === mode;
    },
    setWorkflow(workflow) {
      this.workflow = workflow;
    },
    isWorkflow(workflow) {
      return this.workflow === workflow;
    },
    // Store route name and params before login redirect
    setRedirectRoute(routeName, routeParams = null, routeQuery = null) {
      this.redirectRouteName = routeName;
      this.redirectRouteParams = routeParams;
      this.redirectRouteQuery = routeQuery;
    },
    setCurrentOrderId(orderId) {
      this.currentOrderId = orderId;
    },
    setCurrentOrderGuid(orderGuid) {
      this.currentOrderGuid = orderGuid;
    },
    setCurrentOrderMenuOrderType(orderType) {
      this.currentOrderMenuOrderType = orderType;
    },
    setCurrentMealPlanOrderId(orderId) {
      this.currentMealPlanOrderId = orderId;
    },
    setSelectedMealPlanDate(date) {
      this.selectedMealPlanDate = date;
    },
    armExternalBackGuard() {
      this.externalBackGuardArmed = true;
    },
    clearExternalBackGuard() {
      this.externalBackGuardArmed = false;
    },
    armExternalEntryRootRoute(routeName) {
      this.externalEntryRootRouteName = routeName || null;
    },
    clearExternalEntryRootRoute() {
      this.externalEntryRootRouteName = null;
    },
    isExternalEntryRootRoute(routeName) {
      return !!routeName && this.externalEntryRootRouteName === routeName;
    },
    setOrderEntryRoute(routeName) {
      this.orderEntryRouteName = routeName || null;
      this.tableOrderEntryRouteName = routeName || null;
    },
    clearOrderEntryRoute() {
      this.orderEntryRouteName = null;
      this.tableOrderEntryRouteName = null;
    },
    setTableOrderEntryRoute(routeName) {
      this.setOrderEntryRoute(routeName);
    },
    clearTableOrderEntryRoute() {
      this.clearOrderEntryRoute();
    },
    setFlashToast(toast) {
      this.flashToast = toast;
    },
    consumeFlashToast() {
      const toast = this.flashToast;
      this.flashToast = null;
      return toast;
    },
    // Clear after redirection
    clearRedirectRoute() {
      this.redirectRouteName = null;
      this.redirectRouteParams = null;
      this.redirectRouteQuery = null;
    },
    allowTableModeParametersNavigation() {
      this.allowTableModeOrderParametersNavigation = true;
    },
    disallowTableModeParametersNavigation() {
      this.allowTableModeOrderParametersNavigation = false;
    },
  },
  persist: {
    storage: sessionStorage,
  },
});
